module.exports = __webpack_public_path__ + "images/stickers/taco-reading.97813e2450fd98bf6cfb.png";